import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { withSitecoreContext, Image, Link, Placeholder } from "@sitecore-jss/sitecore-jss-react";
import { STATUS_SUCCESS } from "@clarion/foundation/dist/Settings/constants/index";
import { toggleLoginModal } from "@clarion/foundation/dist/Settings/actions/globalActions";
import { toggleLoadRegisterModals, toggleLoadForgottenPasswordModals } from "@clarion/foundation/dist/Settings/actions/loaderActions";
import { userIsLoggedIn } from "@clarion/foundation/dist/Utils/userUtils";
import AccountIcon from "@clarion/foundation/dist/Theming/icons/AccountIcon";
import { checkIsEditing } from "@clarion/foundation/dist/Utils/sitecoreUtils";
import ReciteMe from "./ReciteMe";
import "./index.css";
const Header = ({
  fields,
  sitecoreContext,
  rendering
}) => {
  const isLoggedIn = userIsLoggedIn(sitecoreContext);
  const isEditing = checkIsEditing(sitecoreContext);
  const dispatch = useDispatch();
  const routeFields = sitecoreContext.route.fields;
  const enableReciteMe = fields.EnableReciteMe.value && routeFields.ReciteMeFeatureToggle?.value;
  const clearRepairsJourneySession = () => {
    window.sessionStorage.removeItem("Repairs");
  };
  const logout = event => {
    clearRepairsJourneySession();
    if (!event.key || event.key === "Enter") {
      fetch("/api/account/logout-user", {
        method: "POST"
      }).then(response => {
        if (response.status === STATUS_SUCCESS) {
          window.location.href = "/";
        }
      });
    }
  };
  const openLogin = () => {
    dispatch(toggleLoginModal(true));
    dispatch(toggleLoadRegisterModals(true));
    dispatch(toggleLoadForgottenPasswordModals(true));
  };
  return /*#__PURE__*/React.createElement("header", {
    className: `header ${enableReciteMe ? "header--recite-me" : ""}`
  }, enableReciteMe && /*#__PURE__*/React.createElement("div", {
    className: "header__reciteme header__reciteme--mobile"
  }, /*#__PURE__*/React.createElement(ReciteMe, {
    fields: fields
  })), /*#__PURE__*/React.createElement("div", {
    className: "header__wrapper wrapper wrapper--wide"
  }, fields.Logo && fields.Logo.value && fields.Logo.value.src && /*#__PURE__*/React.createElement(Fragment, null, isEditing ? /*#__PURE__*/React.createElement("span", {
    className: "header__logo"
  }, /*#__PURE__*/React.createElement(Image, {
    media: fields.Logo,
    width: "200",
    height: "77",
    imageParams: {
      w: 200,
      h: "auto",
      mw: 200
    }
  })) : /*#__PURE__*/React.createElement("a", {
    className: "qa-header__logo header__logo",
    href: "/"
  }, /*#__PURE__*/React.createElement(Image, {
    media: fields.Logo,
    width: "200",
    height: "77",
    imageParams: {
      w: 200,
      h: "auto",
      mw: 200
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "header__main"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__actions"
  }, enableReciteMe && /*#__PURE__*/React.createElement("div", {
    className: "header__reciteme"
  }, /*#__PURE__*/React.createElement(ReciteMe, {
    fields: fields
  })), isLoggedIn ? /*#__PURE__*/React.createElement("div", {
    className: "qa-header__account header__account qa-header__account--logged-in header__account--logged-in"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "qa-logged-in-cta header__account-cta btn btn--secondary btn--coral",
    field: fields.MyAccountLink
  }, /*#__PURE__*/React.createElement(AccountIcon, {
    className: "header__account-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "qa-header__account-label header__account-label"
  }, fields.MyAccountLink.value.text)), fields.LogoutLabel && fields.LogoutLabel.value && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "qa-header__logout-cta header__logout-cta btn btn--secondary btn--coral",
    onClick: logout,
    onKeyDown: logout
  }, fields.LogoutLabel.value)) : /*#__PURE__*/React.createElement("div", {
    className: "header__account qa-header__account header__account--logged-out"
  }, fields.UnauthenticatedLabel && fields.UnauthenticatedLabel.value && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "header__account-cta btn btn--small btn--coral",
    onClick: openLogin
  }, /*#__PURE__*/React.createElement(AccountIcon, {
    className: "header__account-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "qa-header__account-label header__account-label"
  }, fields.UnauthenticatedLabel.value)))), /*#__PURE__*/React.createElement("div", {
    className: "header__menu"
  }, /*#__PURE__*/React.createElement(Placeholder, {
    name: "navigation",
    rendering: rendering
  })))));
};
export default withSitecoreContext()(Header);